import {AxiosError} from 'axios';
import {i18n} from 'next-i18next';

const isAxiosError = (
  e: unknown
): e is AxiosError<{message?: string; fields?: object}> => {
  // @ts-ignore
  return Boolean(e?.isAxiosError);
};

const getUnknownErrorMessage = () =>
  i18n?.t('error:unknown-error-try-again') ??
  'An unknown error occurred. Please try again later.';

export const parseError = (e: unknown) => {
  if (isAxiosError(e)) {
    if (e.response === undefined) {
      return new Error(getUnknownErrorMessage());
    }
    if (e.response.data.fields !== undefined) {
      const errArr = parseNestedFields(e.response.data);
      const errArrStr = errArr.join(',\n');
      return new Error(errArrStr);
    }
    return new Error(e.response?.data.message || getUnknownErrorMessage());
  }

  if (e instanceof Error) {
    return e;
  }
  if (typeof e === 'string') {
    return new Error(e);
  }
  // Plain payloads, e.g. socket errors sent as {message}.
  if (
    typeof e === 'object' &&
    e !== null &&
    typeof (e as {message?: unknown}).message === 'string'
  ) {
    return new Error((e as {message: string}).message);
  }
  // @ts-ignore
  return new Error(getUnknownErrorMessage());
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const parseNestedFields = (data: any): string[] => {
  const result: string[] = [];

  if (data && data.fields) {
    const nestedFields = data.fields.fields;
    for (const key in nestedFields) {
      const value = nestedFields[key];
      if (Array.isArray(value)) {
        result.push(...value);
      }
    }
  }

  return result;
};
